<app-split-pane
  storageKey="split.repos"
  [initialLeftRatio]="0.4"
  [collapseBreakpointPx]="1024"
  [collapsedOnSmallScreens]="true"
>
  <ng-container left>
    @if (!reposStore.activeProjectId() || reposStore.loading()) {
      <app-split-pane-vertical storageKey="split.repos.left" [initialTopRatio]="0.7">
        <ng-container top>
          <div class="p-3">
            <div class="card border-0 shadow-sm p-3">
              <app-skeleton-block height="14px" width="44%" rounded="8px"></app-skeleton-block>
              <div class="mt-3"></div>
              <app-skeleton-block [lines]="6" height="12px" width="100%" rounded="8px" gap="10px"></app-skeleton-block>
              <div class="mt-3"></div>
              <app-skeleton-block height="44px" width="100%" rounded="10px"></app-skeleton-block>
            </div>
          </div>
        </ng-container>
        <ng-container bottom>
          <div class="p-3">
            <div class="card border-0 shadow-sm p-3">
              <app-skeleton-block height="14px" width="30%" rounded="8px"></app-skeleton-block>
              <div class="mt-3"></div>
              <app-skeleton-block [lines]="5" height="12px" width="100%" rounded="8px" gap="10px"></app-skeleton-block>
            </div>
          </div>
        </ng-container>
      </app-split-pane-vertical>
    } @else {
      <app-split-pane-vertical storageKey="split.repos.left" [initialTopRatio]="0.7">
        <ng-container top>
          <app-chat
            [conversationId]="reposStore.activeProjectId()"
            [suggestions]="repoSuggestions"
            [context]="repoContext"
            [orchestratorPageContext]="reposOrchestratorContext"
            [initialMessages]="reposStore.chatMessages()"
            (messagesChange)="onChatMessagesChange($event)"
            (messageCreated)="onChatMessageCreated($event)"
            (aiResult)="onAiResult($event)"
            placeholder="Ask about repositories..."
          ></app-chat>
        </ng-container>
        <ng-container bottom>
          <app-history scopeKey="repos.chat"></app-history>
        </ng-container>
      </app-split-pane-vertical>
    }
  </ng-container>

  <ng-container right>
    <app-split-pane-vertical storageKey="split.repos.right" [initialTopRatio]="0.7">
      <ng-container top>
        <div class="container py-3 repos-main-wrap">
          <app-repos-workspace></app-repos-workspace>
        </div>
      </ng-container>
      <ng-container bottom>
        <app-history scopeKey="repos.main"></app-history>
      </ng-container>
    </app-split-pane-vertical>
  </ng-container>
</app-split-pane>
